export default __webpack_public_path__ + "static/media/cp_geo_mn.9e1ee95d.svg";